/**
 * @GENERATED from Figma node 693:15942
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleAnalyticsBright = (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#E37400"
      d="M4.763 22a2.774 2.774 0 0 0 2.763-2.785 2.774 2.774 0 0 0-2.763-2.784A2.774 2.774 0 0 0 2 19.215 2.774 2.774 0 0 0 4.763 22M9.5 11.908v7.454C9.5 21.056 10.714 22 12 22c1.19 0 2.5-.803 2.5-2.638v-7.34C14.5 10.47 13.31 9.5 12 9.5s-2.5 1.07-2.5 2.408"
    />
    <path
      fill="#F9AB00"
      d="M16.167 4.386v15c0 1.679 1.416 2.614 2.916 2.614 1.39 0 2.917-.796 2.917-2.614V4.5C22 2.961 20.611 2 19.083 2s-2.916 1.06-2.916 2.386"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleAnalyticsBright);
export { ForwardRef as GoogleAnalyticsBright };
